import { Button, Typography } from "@mui/material";

export default function ButtonGradient({
  text,
  borderRadius = "1000px",
  fullwidth = false,
  disabled = false,
  onClick,
}) {
  return (
    <Button
      disabled={disabled}
      onClick={onClick}
      sx={{
        opacity: disabled ? 0.3 : 1,
        display: fullwidth ? "block" : "inlineflex",
        width: fullwidth ? "100%" : "auto",
        padding: "10px 30px",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: borderRadius,
        background:
          "radial-gradient(76.16% 76.16% at 31.97% 19.67%, rgba(255, 255, 255, 0.70) 0%, rgba(255, 255, 255, 0.00) 69.79%, rgba(255, 255, 255, 0.00) 100%), #3672E9",
        boxShadow:
          "2px 20px 30px 0px rgba(0, 0, 0, 0.20), -1.5px -2px 5px 0px rgba(255, 255, 255, 0.15) inset",
        "&:hover": {
          background:
            "radial-gradient(76.16% 76.16% at 31.97% 19.67%, rgba(255, 255, 255, 0.70) 0%, rgba(255, 255, 255, 0.00) 69.79%, rgba(255, 255, 255, 0.00) 100%), #365DE9",
        },
      }}
    >
      <Typography
        variant="h4"
        sx={{
          textTransform: "none",
          fontFamily: "Poppins",
          color: "rgba(255, 255, 255, 0.90)",
          textAlign: "center",
          textShadow: "1px 1px 1px rgba(0, 0, 0, 0.25)",
          fontSize: { xs: 12, lg: 13 },
          fontWeight: "600",
        }}
      >
        {text}
      </Typography>
    </Button>
  );
}
